export default {
  wards: [],
  wardTo: [],
  wardFrom: [],
  ward: {},
  wardsByDistrictCode: {},
  wardsByDistrictId: {}
}



// WEBPACK FOOTER //
// ./src/components/ward/store/state.js